module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg3-d8d6b19d32c26e12a185d8f9917ba3f4.png";